var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 8.15 3.91",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2f2f2990-f230-4beb-b75a-0d30b0ee24e4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed00d0d1-53b1-4352-921b-40a08b9c8fdb",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeWidth: 0,
    d: "M2.26.74,1,2,2.26,3.17a.43.43,0,0,1-.61.61L.13,2.26a.43.43,0,0,1,0-.61L1.65.13a.43.43,0,0,1,.61.61M8,1.65,6.5.13a.43.43,0,0,0-.61,0,.42.42,0,0,0,0,.6L7.11,2,5.89,3.17a.42.42,0,0,0,0,.6.43.43,0,0,0,.61,0L8,2.25a.42.42,0,0,0,0-.6M4.74.11a.43.43,0,0,0-.55.26l-1,2.85a.43.43,0,0,0,.26.56A.45.45,0,0,0,4,3.52L5,.67A.44.44,0,0,0,4.74.11"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.459e127f.svg";
export { ForwardRef as ReactComponent };